import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import HudLoader from "@/components/HudLoader";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <HudLoader />;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
